import { renderSafeHtml } from "../utils/renderSafeHtml";
// import "./richText.css";

const RichText = ({ html }) => {
  if (!html) return null;

  return (
    <div
      className="quill-content"
      dangerouslySetInnerHTML={{
        __html: renderSafeHtml(html),
      }}
    />
  );
};

export default RichText;